<template>
    <CommonDialog :value="value" :title="title" :fullscreen="true" show-action-toolbar @input="$emit('input', false)">
        <v-container>
            <v-row>
                <v-col cols="2"></v-col>
                <v-col cols="5">
                    <v-card color="#f7f7f7" elevation="10">
                        <v-card-text>
                            <v-text-field v-model="label" :label="$t('QRCodeLabel')" outlined dense></v-text-field>
                            <v-file-input v-model="logoFile" :label="$t('UploadLogo')" @change="handleFileUpload" outlined dense></v-file-input>
                            <v-row>
                                <v-col cols="6"><v-text-field v-model="qrOptions.width" :label="$t('Width')" type="number" outlined dense></v-text-field></v-col>
                                <v-col cols="6"><v-text-field v-model="qrOptions.height" :label="$t('Height')" type="number" outlined dense></v-text-field></v-col>
                                <v-col cols="6">
                                    <label>{{$t('LinesColor')}}</label>
                                    <v-color-picker v-model="qrOptions.color.dark" :label="$t('LinesColor')" outlined dense></v-color-picker>
                                </v-col>
                                <v-col cols="6">
                                    <label>{{$t('BackgroundColor')}}</label>
                                    <v-color-picker v-model="qrOptions.color.light" :label="$t('BackgroundColor')" outlined dense></v-color-picker>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col cols="3">
                    <v-card color="primary" height="570">
                        <v-card-subtitle><div ref="qrcode" class="qrcode-container"></div></v-card-subtitle>
                        <v-card-actions>
                            <v-spacer />
                            <v-btn color="black" class="white--text" @click="downloadQRCode">{{$t('DOWNLOADQRCODE')}}</v-btn>
                            <v-spacer />
                        </v-card-actions>
                    </v-card>
                </v-col>
                <v-col cols="2"></v-col>
            </v-row>
        </v-container>
    </CommonDialog>
</template>

<script>
    import QRCode from 'qrcode'
    import CommonDialog from '@/components/controls/CommonDialog'

    export default {
        components: {
            CommonDialog
        },
        props: {
            title: {
                type: String,
                default: ''
            },
            surveyURL: {
                type: String,
                default: ''
            },
            value: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                label: '',
                logoFile: null,
                logoImage: null,
                qrOptions: {
                    width: 256,
                    height: 256,
                    color: {
                        dark: '#000000',
                        light: '#ffffff'
                    },
                    errorCorrectionLevel: 'H' // Use string 'H' for high error correction level
                }
            }
        },
        watch: {
            surveyURL: 'generateQRCode',
            label: 'generateQRCode',
            'qrOptions.width': 'generateQRCode',
            'qrOptions.height': 'generateQRCode',
            'qrOptions.color.dark': 'generateQRCode',
            'qrOptions.color.light': 'generateQRCode'
        },
        async mounted() {
            this.$nextTick().then(() => {
                this.generateQRCode()
            })
        },
        methods: {
            async generateQRCode() {
                const qrcodeElement = this.$refs.qrcode

                if (!qrcodeElement) {
                    return
                }

                qrcodeElement.innerHTML = '' // Clear previous QR code

                const canvas = document.createElement('canvas')
                const context = canvas.getContext('2d')
                const qrCodeCanvas = document.createElement('canvas')

                await QRCode.toCanvas(qrCodeCanvas, this.surveyURL || this.label, {
                    width: this.qrOptions?.width || 256,
                    height: this.qrOptions?.height || 256,
                    color: {
                        dark: this.qrOptions?.color?.dark || '#000000',
                        light: this.qrOptions?.color?.light || '#ffffff'
                    },
                    errorCorrectionLevel: this.qrOptions?.errorCorrectionLevel || 'H'
                })

                canvas.width = qrCodeCanvas.width
                canvas.height = qrCodeCanvas.height + 30 // Adjust height to include label

                context.drawImage(qrCodeCanvas, 0, 0)

                if (this.logoImage) {
                    const logoSize = qrCodeCanvas.width / 5 // Adjust logo size
                    const x = (qrCodeCanvas.width - logoSize) / 2
                    const y = (qrCodeCanvas.height - logoSize) / 2
                    context.drawImage(this.logoImage, x, y, logoSize, logoSize)
                }

                // Add label below QR code
                context.font = '16px Arial'
                context.textAlign = 'center'
                context.fillText(this.label, canvas.width / 2, qrCodeCanvas.height + 20)

                qrcodeElement.appendChild(canvas)
            },
            handleFileUpload(file) {
                if (file) {
                    const reader = new FileReader()
                    reader.onload = (e) => {
                        this.logoImage = new Image()
                        this.logoImage.src = e.target.result
                        this.logoImage.onload = () => this.generateQRCode()
                    }
                    reader.readAsDataURL(file)
                } else {
                    console.log('No file selected')
                }
            },
            downloadQRCode() {
                const canvas = this.$refs.qrcode.querySelector('canvas')
                if (canvas) {
                    console.log('Canvas found:', canvas)
                    const dataURL = canvas.toDataURL('image/png')
                    console.log('Data URL:', dataURL)
                    const link = document.createElement('a')
                    link.href = dataURL
                    link.download = 'qrcode.png'
                    link.click()
                } else {
                    console.log('No QR code canvas found to download')
                }
            }
        }
    }
</script>

<style scoped>
    .qrcode-container {
        text-align: center;
    }
</style>
